<template>
  <div class="wh-container">
    <div class="header">
      <p class="title">Histórico de solicitações</p>
    </div>

    <div class="body">
      <div class="subheader">
        <div class="title">Histórico das minhas solicitações</div>

        <div>
          <b-button
            class=""
            variant="primary"
            outline
            @click="openStockRequestModal()"
          >
            Nova solicitação
          </b-button>
        </div>
      </div>

      <div class="row">
        <b-col cols="5">
          <b-form-group>
            <InputSearch
              autocomplete="off"
              class="placeholder-color mr-2"
              id="search"
              debounce="300"
              placeholder="Nome do produto"
              v-model="filters.product"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-button variant="primary" class="mr-2">Aplicar</b-button>
          <b-button variant="outline-primary" @click="openInfoSidebar()" class="button-wrapper">
            <FilterIcon class="mr-2" /> Filtros
            <div v-if="filterApplied" class="pulsating-circle"></div>
          </b-button>
        </b-col>
      </div>

      <div class="my-3">
        <div>
          <b-table-simple id="tb-request" class="p-table" responsive>
            <thead class="table-header">
              <tr>
                <td class="td-header">Prio.</td>
                <td class="td-header">N. Solic.</td>
                <td class="td-header">Data</td>
                <td class="td-header">Produto</td>
                <td class="td-header">Destino</td>
                <td class="td-header">Qtd.</td>
                <td class="td-header">Unid.</td>
                <td class="td-header">Observação</td>
                <td class="td-header">Status</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(productRequest, index) in productRequests"
                :key="index"
              >
                <td class="td-body">
                  <div class="priority-icon">
                    <component
                      :is="getPriority(productRequest.priority_code)"
                    />
                  </div>
                </td>
                <td class="td-body">
                  {{ productRequest.request?.number }}
                </td>
                <td class="td-body">
                  {{
                    moment(productRequest.request?.request_date).format(
                      'DD/MM/YY'
                    )
                  }}
                </td>
                <td class="td-body td-product-name">
                  {{ productRequest.product?.name }}
                </td>
                <td class="td-body">
                  {{
                    productRequest.request?.sector?.stock?.name +
                    ' - ' +
                    productRequest.request?.sector?.name
                  }}
                </td>
                <td class="td-body">
                  {{ productRequest.quantity ?? '' }}
                </td>
                <td class="td-body">
                  {{ productRequest.unit?.name ?? '' }}
                </td>
                <td class="td-body td-observacao text-center cursor-pointer">
                  <Icon>
                    <Comment
                      class="icon icon-comment"
                      @click="openModalComment(index)"
                    />
                    {{
                      productRequest.comments?.length
                        ? productRequest.comments?.length
                        : 0
                    }}
                  </Icon>
                </td>
                <td class="td-body actions">
                  <span :class="['status', productRequest.status]">{{
                    getStatus(productRequest.status)
                  }}</span>
                </td>
                <td class="td-body actions">
                  <div
                    class="btn-group btn-group-sm actions"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                        v-if="userHasPermission('EstNovaSol2') && productRequest.status === 'pendente'"
                        type="button"
                        class="btn p-1"
                        @click="editStockRequestModal(productRequest)"
                    >
                      <Icon>
                        <Edit class="icon icon-edit" />
                      </Icon>
                    </button>
                    <button
                      v-if="userHasPermission('EstNovaSol3') && productRequest.status === 'pendente'"
                      type="button"
                      class="btn p-1"
                      @click="deleteProductRequest(productRequest.id)"
                    >
                      <Icon>
                        <Trash class="icon icon-trash" />
                      </Icon>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </b-table-simple>
        </div>
      </div>
    </div>

    <CommentRequestModal
        ref="commentModalByHistory"
        :product="selectedProductRequest"
        @update-product-request-comment="updateProductRequestComment"
    />

    <FilterSidebar
      @change="updateFilter"
      @updateFilterApplied="updateFilterApplied"
      :query="filters.product"
    />
  </div>
</template>

<script>
import { getCurrentClinic, getCurrentUser, userHasPermission } from '@/utils/localStorageManager'
import api from '@/modules/warehouse/api'
import CommentRequestModal from '@/components/Warehouse/StockRequests/CommentRequestModal.vue'
import { EventBus } from '@/utils/eventBus'

export default {
  name: 'RequestHistory',
  metaInfo: {
    title: 'Eyecare -  Histórico de solicitações'
  },
  components: {
    CommentRequestModal,
    Comment: () => import('@/assets/icons/comment.svg'),
    Edit: () => import('@/assets/icons/edit.svg'),
    FilterIcon: () => import('@/assets/icons/filter.svg'),
    Priority4: () => import('@/assets/icons/flag-red.svg'),
    Priority3: () => import('@/assets/icons/flag-yellow.svg'),
    Priority2: () => import('@/assets/icons/flag-green.svg'),
    Priority1: () => import('@/assets/icons/flag-blue.svg'),
    Priority0: () => import('@/assets/icons/flag-transparent.svg'),
    Trash: () => import('@/assets/icons/trash.svg'),

    FilterSidebar: () => import('./HistoryFilterSidebar.vue'),
    Icon: () => import('@/components/General/Icon'),
    InputSearch: () => import('@/components/General/InputSearch'),
  },
  async mounted() {
    this.getProductStockRequests();

    EventBus.$on('refreshStockRequests', (message) => {
      this.getProductStockRequests();
    });
  },
  async created() {},
  data() {
    return {
      clinic: getCurrentClinic(),
      user: getCurrentUser(),
      filterApplied: false,
      query: '',
      loading: false,
      productRequests: [],
      count: 0,
      limit: 15,
      selectedProductRequest: {},
      filters: {},
      selectedRequest: {},
    }
  },
  computed: {},
  methods: {
    userHasPermission,
    getProductStockRequests(loading = true) {
      let isLoading = null

      if (loading) isLoading = this.$loading.show()

      const params = {
        clinicId: this.clinic.id,
        userId: this.user.id,
        filters: this.filters
      }

      api
        .getProductStockRequests(params)
        .then(res => {
          this.productRequests = res.data.data
          this.count = res.data.total
          this.limit = res.data.per_page
        })
        .catch(err => this.$toast.error(err.message))
        .finally(() => {
          isLoading && isLoading.hide()
        })
    },
    deleteProductRequest(productRequestId) {
      api
        .deleteProductStockRequests(productRequestId)
        .then(res => {
          this.$toast.success('Solicitaçao removida com sucesso!')
        })
        .catch(err => this.$toast.error(err.message))
        .finally(() => {
          this.getProductStockRequests(false)
        })
    },
    getPriority(priority) {
      return 'Priority' + priority
    },
    getStatus(status) {
      const arrStatus = {
        entregue: 'Entregue',
        entregue_parcial: 'Entregue Parcial',
        reprovado: 'Reprovado',
        pendente: 'Pendente'
      }

      return arrStatus[status] || '-'
    },
    openInfoSidebar() {
      this.$root.$emit('bv::toggle::collapse', 'filter-history-sidebar')
    },
    async updateFilter(newFilter) {
      this.filters = newFilter
      this.currentPage = 1
      this.rows = []
      this.getProductStockRequests();
    },
    async updateFilterApplied() {
      const filters = this.filters

      for (var propName in filters) {
        if (
          filters[propName] === null ||
          filters[propName] === undefined ||
          filters[propName] === ''
        ) {
          delete filters[propName]
        }
      }

      delete filters.page
      delete filters.type

      this.filterApplied = Object.values(filters).length > 0
    },
    openStockRequestModal() {
      this.$bvModal.show('stock-request-modal')
    },
    async editStockRequestModal(productRequest) {
      api.findStockRequest(productRequest.request.id)
          .then(res => {
            this.selectedRequest = res.data;
            EventBus.$emit('editStockRequests', this.selectedRequest);
            this.$bvModal.show('stock-request-modal')
          })
          .catch(err => this.$toast.error(err.message));
    },
    openModalComment(index) {
      this.productRequests[index].index = index
      this.selectedProductRequest = this.productRequests[index]
      this.$bvModal.show('comment-request-modal')
    },
    async updateProductRequestComment(product){
      await api.createProductStockComment({
        'product_stock_request_id': product.id,
        ... product.comments[product.comments.length - 1]
      });
    }
  },
  watch: {
    'filters.product': function () {
      this.getProductStockRequests();
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/table.scss';

.wh-container {
  height: 100%;
  padding: 30px 24px;

  .pulsating-circle {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    background-color: var(--orange);
    border-radius: 50%;
    width: 10px;
    height: 10px;
  }


  .subheader {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 30px 0;

    .title {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      text-align: left;
      color: #525c7a;
    }
  }

  .body {
    background-color: white;
    padding: 15px;
    border-radius: 8px;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: end;
    margin-bottom: 24px;
  }

  .title {
    font-family: 'Red Hat Display';
    font-weight: 700;
    font-size: 24px;
    color: var(--dark-blue);

    span {
      font-size: 12px;
      line-height: 130%;
      font-weight: 600;
      color: var(--type-active);
    }
  }

  .exams-sidebar__body {
    padding: 5px;

    .sidebar-header {
      padding: 10px 0;
      font-family: Red Hat Display;
      font-size: 18px;
      font-weight: 700;
      text-align: left;
      color: #0c1d59;
    }

    label {
      font-weight: 400;
    }
  }

  .filter-button {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .ellipse-applied-filter {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 50%;

    /* Orange */
    background: #ff6b00;

    right: -22px;
    top: -16px;
  }

  .b-skeleton {
    height: 3vh;
  }

  .icon {
    width: 24px;
    height: 24px;
  }

  .table-data {
    background-color: #ffffff !important;
    border-radius: 8px;
  }

  .priority-icon {
    background-color: #f4f5fb;
    height: 35px;
    width: 35px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    padding: 5px;

    svg {
      margin: auto;
    }
  }

  #tb-request {
    .td-product-name {
      width: 250px;
    }
    .td-observacao {
      width: 100px;
    }
    .cursor-pointer {
      cursor: pointer;
    }
    .actions {
      width: 80px;
    }
    .status {
      padding: 5px 10px;
      border-radius: 100px;

      &.entregue {
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;
      }

      &.reprovado {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
      }

      &.pendente {
        color: #ff9900;
        background-color: #ffebcc;
        border-color: #ffebcc;
      }

      &.entregue_parcial {
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;
      }
    }
  }
}
</style>